// Filter out duplicate menu items based on displayname
export const filterDuplicateMenus = (menuData) => {
    const seen = new Set();
    return menuData.filter(item => {
        const duplicate = seen.has(item.displayname);
        seen.add(item.displayname);
        return !duplicate;
    });
};

// Sort menu items by displayorder from the API in descending order (numbers like 1000, 2000, etc.)
export const sortMenuItems = (menuData) => {
    return menuData.sort((a, b) => {
        const orderA = a.displayorder || 0;
        const orderB = b.displayorder || 0;
        return orderB - orderA;
    });
};

// Process menu data to remove duplicates and sort
export const processMenuData = (menuData) => {
    if (!Array.isArray(menuData)) return [];
    
    const filtered = filterDuplicateMenus(menuData);
    return sortMenuItems(filtered);
}; 